export default __webpack_public_path__ + "static/media/bismillah.505aed5f.png";